export default "__VITE_ASSET__Bzvxna_N__"